import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BcmNetworkPrinter } from '@shared/models/network-printer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { BcmService } from '@modules/bcm/bcm.service';
import { LocalPrintRelayToolDescriptor } from '@modules/bcm/@shared/services/local-print-relay-watchdog.service';

@Injectable({providedIn: 'root'})
export class NetworkPrintersService implements Resolve<BcmNetworkPrinter[]> {

    private readonly path = `${environment.endpoints.bcm.api}${this._bcmService.tenant.id}/network-printers`;

    constructor(private _activatedRoute: ActivatedRoute,
                private _bcmService: BcmService,
                private _httpClient: HttpClient) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<BcmNetworkPrinter[]> {
        return this.loadAll();
    }

    loadAll(): Observable<BcmNetworkPrinter[]> {
        return this._httpClient.get<BcmNetworkPrinter[]>(this.path).pipe(
            map(printers => (printers ?? []).map(p => new BcmNetworkPrinter(p)))
        );
    }

    create(netWorkPrinter: Partial<BcmNetworkPrinter>): Observable<BcmNetworkPrinter> {
        return this._httpClient.post<BcmNetworkPrinter>(this.path, netWorkPrinter);
    }

    update(netWorkPrinter: Partial<BcmNetworkPrinter>): Observable<BcmNetworkPrinter> {
        return this._httpClient.put<BcmNetworkPrinter>(`${this.path}/${netWorkPrinter.id}`, netWorkPrinter);
    }

    regeneratePollCredentials(id: number): Observable<BcmNetworkPrinter> {
        return this._httpClient.post<BcmNetworkPrinter>(`${this.path}/${id}/regenerate-poll-credentials`, {});
    }

    delete(netWorkPrinter: BcmNetworkPrinter): Observable<BcmNetworkPrinter> {
        return this._httpClient.delete<BcmNetworkPrinter>(`${this.path}/${netWorkPrinter.id}`);
    }

    downloadRelayTool(descriptor: LocalPrintRelayToolDescriptor): Observable<Blob> {
        let params = new HttpParams();

        if (descriptor.platform === 'macos' && descriptor.macArchitecture) {
            params = params.set('arch', descriptor.macArchitecture);
        }

        return this._httpClient.get(
            `${this.path}/print-relay-tool/${descriptor.platform}`,
            { responseType: 'blob', params }
        );
    }
}
